import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import "../../style/sidemenu-pages-style/UserLibrary.css";
import ProjectPreBuiltTemplateGrid from "./Prebuilt_Template/ProjectPreBuiltTemplateGrid";

const ProjectPreBuiltTemplate = () => {
  const { t } = useTranslation();
  return (
    <MainContainer>
      <PageTitleContainer>
        <Typography variant="Page Title">{t("Pre-Built Template")}</Typography>
      </PageTitleContainer>
      <ProjectPreBuiltTemplateGrid />
    </MainContainer>
  );
};

export default ProjectPreBuiltTemplate;
